import { trpc } from "../../main/components/trpc.ts";
import useAllUsers from "../../users/hooks/useAllUsers";
import useUser from "../../users/hooks/useUser";
import Thread from "./Thread";
import styles from "./MessagesPage.module.css";
import _ from "underts";
import { useSelectedPatientIds } from "../../main/state/globalState";
import { useState } from "react";
import { messagesToThreadsPipeline } from "../filterTransform/messagesToThreadPipeline";

const MessagesPage = () => {
  const [_msgPatientId, setMsgPatientId] = useState<string | null>(null);
  const [startDate] = useState<Date>(
    new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
  );

  const [endDate] = useState<Date>(
    new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
  );
  const doctorMessages =
    trpc.message.getAllDoctorMessages.useQuery({ startDate, endDate }).data ||
    [];
  const allUsers = useAllUsers();
  const user = useUser();
  const [selectedPatientIds, { selectPatientId }] = useSelectedPatientIds();

  const threads =
    (user && messagesToThreadsPipeline(doctorMessages, user, allUsers)) || [];

  return (
    <div className={styles.container}>
      <div>Messages</div>
      {Object.values(threads).map((messages) => {
        const msg = _.first(messages);
        if (!msg) {
          return null;
        }
        const thread_id = msg.thread_id;
        return (
          <div key={thread_id} className={styles.threadDiv}>
            <Thread
              onReplyClick={() => {}}
              replyText=""
              onMessageClick={() => {}}
              onReplySend={() => {}}
              onReplyTextChange={() => {}}
              threadId={thread_id}
              messages={messages}
              isDoctor={false}
              onArchiveClick={() => {}}
              isResponding={false}
              onEmergencyClick={() => {}}
              onQuestionClick={() => {}}
              onCallClick={() => {}}
              onWaitingClick={() => {}}
              onDoneClick={() => {}}
              msgReplyType="info"
              name=""
              firstName=""
              onReplyCancel={() => {}}
              onSelectPatient={selectPatientId}
              onSelectPatientForMessage={() =>
                setMsgPatientId(_.first(selectedPatientIds) || null)
              }
              onRespondReplayClick={() => {}}
              showReplyLink={true}
            />
          </div>
        );
      })}
    </div>
  );
};

export default MessagesPage;
